"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJsonAltKeyFromField = exports.getJsonKeyFromField = exports.tryParseJSON = void 0;
const tryParseJSON = (jsonString, defaultValue) => {
    if (jsonString === undefined) {
        return defaultValue;
    }
    try {
        if (typeof jsonString !== 'string') {
            return jsonString;
        }
        const o = JSON.parse(jsonString);
        return o;
    }
    catch (e) {
        if (defaultValue) {
            return defaultValue;
        }
        return jsonString;
    }
};
exports.tryParseJSON = tryParseJSON;
const getJsonKeyFromField = (field) => {
    if (field?.type_properties?.json_key) {
        return field.type_properties?.json_key;
    }
    return field?.field_name?.replace(/ /g, '_').toLocaleLowerCase();
};
exports.getJsonKeyFromField = getJsonKeyFromField;
const getJsonAltKeyFromField = (field) => {
    if (field.type_properties.json_key_alt) {
        return field.type_properties.json_key_alt;
    }
    return null;
};
exports.getJsonAltKeyFromField = getJsonAltKeyFromField;
